var React = require('react');
var LoginStore = require('../../stores/LoginStore.js');
var LoginHelper = require('../../utils/loginHelper');
var {isNil} = require('lodash');

class AuthMethodsHandler extends React.Component {
    constructor(props) {
        super(props);

        this.getUserMFAOptions = this.getUserMFAOptions.bind(this);
        this.state = {
            userMFAMethods: []
        }
    }

    componentDidMount() {
        LoginStore.addGetUserMFAOptions(this.getUserMFAOptions);
    }

    getUserMFAOptions() {
        let appState = LoginStore.getState();   
        const userMFAMethods = appState.userMFAMethods;
        const credentialId = !isNil(userMFAMethods) && userMFAMethods.length > 0 ? LoginHelper.setAuthenticationMethod(userMFAMethods).credentialId : '';
        const authMethodDeviceName = !isNil(userMFAMethods) && userMFAMethods.length > 0 ? LoginHelper.setAuthenticationMethod(userMFAMethods).name : '';
        this.props.setState({userMFAMethods: userMFAMethods,
            credentialId: credentialId, 
            authMethodDeviceName: authMethodDeviceName});
    }

    render() {
        return <div></div>;
    }
}

module.exports = AuthMethodsHandler;